"use client";

import { FC } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/shadcn/ui/form";
import { Input } from "@/components/shadcn/ui/input";
import { Textarea } from "@/components/shadcn/ui/textarea";
import ContactFormPhone from "@/components/uix/forms/Contact/ContactFormPhone";

const ContactFormFields: FC = () => {
  return (
    <>
      <FormField
        name='lastName'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom</FormLabel>
            <FormControl>
              <Input {...field} placeholder='Nom' type='text' autoComplete='family-name' />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name='firstName'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Prénom</FormLabel>
            <FormControl>
              <Input {...field} placeholder='Prénom' type='text' autoComplete='given-name' />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name='email'
        render={({ field }) => (
          <FormItem>
            <FormLabel>E-Mail</FormLabel>
            <FormControl>
              <Input {...field} placeholder='email@mail.fr' type='email' autoComplete='email' />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <ContactFormPhone />
      <FormField
        name='message'
        render={({ field }) => (
          <FormItem>
            <FormLabel>Message</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder='Votre message' />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default ContactFormFields;
